import SaveToShortlistButtonComp, {
  SaveToShortlistButtonProps,
} from '@bridebook/web/app-shared/components/save-to-shortlist-button/save-to-shortlist-button';

interface IProps extends Omit<SaveToShortlistButtonProps, 'isShortlisted' | 'isLoggedIn'> {}

const SaveToShortlistButton = (props: IProps) => (
  <SaveToShortlistButtonComp {...props} isShortlisted={false} isLoggedIn={false} />
);

export default SaveToShortlistButton;
